import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// material-ui
import { useDropzone } from 'react-dropzone';
import { Paper, RootRef } from '@material-ui/core';
// common
// import CustomButton from "../CustomButton/CustomButton";
import './Dropzone.scss';

const Dropzone = ({
	input, required, label, alertMsg, onUpload
}) => {
	const maxSize = 20000000;

	const onDrop = useCallback((acceptedFiles) => {
		onUpload(acceptedFiles[0]);
	}, []);

	const {
		acceptedFiles, rejectedFiles, getRootProps, getInputProps, isDragActive, isDragReject
	} = useDropzone({
		accept: '.csv',
		onDrop,
		minSize: 0,
		maxSize,
		multiple: false
	});
	const { ref, ...rootProps } = getRootProps();

	const acceptedFilesItems = acceptedFiles.map((file) => (
		<div key={file.path} className="accepted">
			<span>{file.path}</span>
		</div>
	));

	const rejectedFilesItems = rejectedFiles.map((file) => (
		<div key={file.path} className="rejected">
			<span>{file.path}</span>
			<p className='error-message'>Only .CSV files can be uploaded</p>
		</div>
	));

	const isFileTooLarge = rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize;

	return (
		<div className="Dropzone">
			<div className="dz-label">
				<span>{(label !== 'null' && label !== '') ? label : ''}</span>
				<div className="dzlabel-small">
					(
					{alertMsg}
					)
				</div>
			</div>
			<RootRef rootRef={ref}>
				<Paper classes={{ root: `dropzone root ${required ? 'required' : ''}` }} {...rootProps}>
					<input type="file" {...getInputProps()} />
					{!(acceptedFiles.length > 0 || rejectedFiles.length > 0) && (
						<div className={`place-holder ${(isDragActive && (isDragReject || isFileTooLarge)) ? 'error' : ''}`}>
							{!isDragActive && !isFileTooLarge && !isDragReject && 'Upload CSV (or) Just Drag & Drop'}
							{isDragActive && !isDragReject && 'Drop the files here ....'}
							{isDragActive && isDragReject && 'File type not accepted, sorry!'}
						</div>
					)}
					{(acceptedFiles.length > 0 || rejectedFiles.length > 0) && (
						<aside className="files">
							{!isDragActive && isFileTooLarge && (
								<div className="place-holder error">File is too large.</div>
							)}
							{acceptedFilesItems}
							{rejectedFilesItems}
						</aside>
					)}
				</Paper>
			</RootRef>
		</div>
	);
};

Dropzone.propTypes = {
	input: PropTypes.instanceOf(Object),
	required: PropTypes.bool,
	label: PropTypes.string,
	alertMsg: PropTypes.string,
	onUpload: PropTypes.func
};

Dropzone.defaultProps = {
	input: {},
	required: false,
	label: '',
	alertMsg: '',
	onUpload: () => {}
};

export default Dropzone;



// WEBPACK FOOTER //
// ./common/Dropzone/Dropzone.js